import { Box, FormControl, Image, Input, InputGroup, InputRightElement, SlideFade, Stack, Text } from '@chakra-ui/react';
import { useContext, useState } from 'react';
import { AiOutlineUser } from 'react-icons/ai';
import { FiKey } from 'react-icons/fi';
import Container from '../../components/Container';
import { PrimaryButton } from '../../components/CustomButton';
import { AuthContext } from '../../context/authContext';
import { loginTenant } from './service/login';
import logo from '../login/logo.png';
import { UpdatePassword } from './components/UpdatePassword';
import FullPageLoader from '../../components/FullPageLoader';
import { BsLockFill } from 'react-icons/bs';
import { errorNotifier } from '../../components/NotificationHandler';

const Login = () => {
  const [tenantPhone, setTenantPhone] = useState('');
  const [tenantCode, setTenantCode] = useState('');
  const [loading, setLoading] = useState(false);
  const { setIsLoggedin } = useContext(AuthContext);
  const [nextPage, setNextPage] = useState(false);
  const [data, setData] = useState([]);
  const [showTenantCode, setShowTenantCode] = useState(false);

  // console.log({ tenantPhone, tenantCode });
  const handleLogin = (e) => {
    e.preventDefault();
    sessionStorage.setItem('tenantPhone', tenantPhone);
    sessionStorage.setItem('tenantCode', tenantCode);
    const payload = { tenantCode, tenantPhone, flag: 'Old' };

    if (!payload.tenantCode || !payload.tenantCode) {
      errorNotifier('Input valid details');
      return;
    }
    loginTenant(payload, setLoading, setIsLoggedin, setNextPage, setData);
  };

  return loading ? (
    <FullPageLoader />
  ) : nextPage ? (
    <UpdatePassword data={data} />
  ) : (
    <SlideFade in={true} offsetX='-5000px'>
      <Container>
        <Stack w='100%' as='section' pt='15vh' px='5%'>
          <Box pb='7' align='center'>
            <Image src={logo} alt='logo' height='130px' />
          </Box>
          <Text lineHeight={1} fontWeight='500'>
            Proceed with your
          </Text>
          <Text pb='5' lineHeight={1} fontWeight='600' fontSize='1.5rem'>
            Login
          </Text>
          <FormControl w='100%'>
            <InputGroup>
              <Input
                autoFocus
                {...inputStyles}
                placeholder='Phone Number'
                value={tenantPhone}
                type='number'
                onChange={(e) => setTenantPhone(e.target.value)}
              />
              <InputRightElement children={<AiOutlineUser />} />
            </InputGroup>
            <InputGroup my='7'>
              <Input
                {...inputStyles}
                placeholder='Tenant code'
                value={tenantCode}
                type={!showTenantCode ? 'text' : 'password'}
                onChange={(e) => setTenantCode(e.target.value)}
              />
              <InputRightElement cursor={'pointer'} onClick={() => setShowTenantCode(!showTenantCode)}>
                {showTenantCode ? <FiKey /> : <BsLockFill />}
              </InputRightElement>
            </InputGroup>
            <PrimaryButton loadingText='logging you in' btnText='Login' isLoading={loading} onClick={handleLogin} />
          </FormControl>
        </Stack>
      </Container>
    </SlideFade>

    // </Slide>
  );
};

export default Login;

export const inputStyles = { border: '0', size: 'sm', borderBottom: '1px solid #ddd' };
